export default "__VITE_ASSET__3qSfbMEm__"